var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-chapter-content d-book-chapter font-size-large space-top-2em"},[_c('div',{staticClass:"content",class:{
      'blurred': (_vm.containExplicit && _vm.contentIsHidden),
    }},[_vm._t("chapter")],2),_vm._v(" "),((_vm.containExplicit && _vm.contentIsHidden))?_c('DExplicitOverlay',{staticClass:"explicit-overlay",attrs:{"button-text":"Read preview"},on:{"button-click":_vm.showContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }